<template>
  <v-select
      :disabled="disabledSelection"
      :items="items"
      v-model="selectedItem"
      return-object
      :prepend-inner-icon="navigationItem.meta.icon"
      @click.stop
      item-value="id"
      item-title="year"
      hide-details
      color="primary"
      class=""
      filled
      item-text="id"
  >
    <template v-slot:append-item>
      <v-divider class="mt-1"></v-divider>
      <div class="append ma-1 mb-0">
        <v-btn
            class="append"
            variant="text"
            style="width: 100%"
            @click="toggleDialog"
        >
          Add year
        </v-btn>
      </div>
    </template>
  </v-select>
</template>
<script>
import {mapActions, mapGetters, mapState} from "vuex";

export default {
  name: "YearSelect",
  data: () => ({
    disabledSelection: false,
  }),
  props: {
    navigationItem: {},
  },
  computed: {
    ...mapState("years", {
      items: (state) => state.items,
      currentItem: (state) => state.currentItem,
    }),
    ...mapState("project", {
      currentProject: (state) => state.currentProject,
    }),
    ...mapGetters('project', {
      projectSelectedYear: 'selectedYear',
    }),
    selectedItem: {
      get() {
        return this.projectSelectedYear;
      },
      async set(value) {
        this.setCurrentItem(value)
        await this.updateSelectedYear({
          id: this.currentProject.currentprojectuser.id,
          selectedYear: value
        });
      },
    },
  },
  watch: {
    $route() {
      this.disabledSelection = this.$route.name === "schematisation-stage";
    },
  },
  methods: {
    ...mapActions("years", {
      toggleDialog: "toggleDialog",
      setCurrentItem: "setCurrentItem",
      updateSelectedYear: "updateSelectedYear",
    }),
    ...mapActions("project", {
       fetchProject: "fetchProject",
    }),
  },
  mounted() {
    if (this.$route.name === "schematisation-stage") {
      this.disabledSelection = true;
    }
  },
};
</script>
<style scoped>
.append {
  position: sticky;
  display: flex;
  justify-content: center;
  background: white;
}
</style>
